export const GROOVING_TYPE_CODE_WITHOUT_GROOVING = "without-grooving";
export const GROOVING_TYPE_CODE_SYMMETRICAL_GROOVING = "symmetrical-grooving";
export const GROOVING_TYPE_CODE_ASYMMETRICAL_GROOVING = "asymmetrical-grooving";

export type GroovingType = {
  code: string;
  name: string;
  nameIt: string | null;
  nameDe: string | null;
  nameFr: string | null;
  nameEs: string | null;
  image: string | null;
};

// User side (settings, saved configuration): name already in the user's language.
export type GroovingTypeForSettings = Omit<GroovingType, "nameIt" | "nameDe" | "nameFr" | "nameEs">;

export type SearchGroovingTypesResponse = {
  items: GroovingType[];
  total: number;
};

// export type InsertGroovingTypeBody = {
//   name: string;
//   nameIt: string | null;
//   nameDe: string | null;
//   nameFr: string | null;
//   nameEs: string | null;
//   image?: string | null;
// };

export type UpdateGroovingTypeBody = Omit<GroovingType, "code"> & {
  removeImage?: boolean;
};
